import { useTrackErrorPageView } from "./hooks/use-track-error-page-view.js";
export {
  useTrackErrorPageView
};
//# sourceMappingURL=hooks.js.map
